import 'angular:locale/data:ja';
import 'angular:locale/data:ko';
import 'angular:locale/data:fr-CA';
import 'angular:locale/data:es';
import 'angular:locale/data:en-US';
import '././frontend/main-client/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
